import { styled, css } from "../../styles";

export const PatientListTableContainer = styled("div", {
  marginTop: "$4",
  marginBottom: "36px",

  position: "relative",
  height: "calc(100% - 36px)",
  minHeight: "520px",
  width: "100%",
  boxSizing: "border-box",

  // Card-style wrapper around the table + pagination, matching the look
  // of the patient page's InfiniteTable.
  backgroundColor: "$white",
  border: "1px solid #ECECEC",
  borderRadius: "8px",
  // Column flex so TableFadeWrapper can absorb the available vertical space
  // and pagination always sits flush against the bottom of the card —
  // independent of how many rows the current page has.
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",

  "@sm": {
    marginTop: 0,
  },

  // Strip the inner table/skeleton border + radius + top margin so the outer
  // container reads as a single card. Scoped to the FIRST child (TableFadeWrapper
  // → table) so it doesn't leak onto the Pagination (the other direct child) —
  // `flex: 1` on the pagination pill would stretch it full-width and push the
  // page numbers to the left instead of centering them.
  "& > div:first-child > div:first-child": {
    height: "auto",
    maxHeight: "none",
    overflow: "visible",
    border: "none",
    borderRadius: 0,
    marginTop: 0,
    // Fill the card height so the table's empty state centers vertically (the
    // wrapper is a flex column); with data it still grows to content/scrolls.
    flex: 1,
    minHeight: 0,
  },

  // TableSorted renders an empty <tfoot /> for spacing — hide it so the
  // pagination sits flush against the last row.
  "& tfoot": {
    display: "none",
  },
});

// Grows to fill the card so pagination — the next sibling — is pinned to
// the bottom regardless of row count. Owns the vertical scroll so the
// pagination stays put even when the table overflows. `flex-basis: 0` keeps
// the grow factor honest: without it, the wrapper's intrinsic content
// height would be added before flex distribution and short pages would
// produce a shorter card.
export const TableFadeWrapper = styled("div", {
  transition: "opacity 120ms ease",
  flex: "1 1 0",
  minHeight: 0,
  overflow: "auto",

  // Flex column so the inner table can grow to fill the card and center its
  // empty state vertically.
  display: "flex",
  flexDirection: "column",

  // Match the patient page's InfiniteTable scrollbar styling, lifted from
  // the outer container so the scroll surface is now the wrapper.
  "&::-webkit-scrollbar": {
    width: "$4",
    height: "$4",
  },
  "&::-webkit-scrollbar-track": {
    marginTop: "80px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "$gray-50",
    borderRadius: "10px",
  },

  variants: {
    isFetching: {
      true: {
        opacity: 0.5,
        pointerEvents: "none",
      },
    },
  },
});

export const PatientCountContainer = styled("div", {
  color: "$gray-70",
  fontFamily: "$nunito",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "34px",
  marginLeft: "5px",
});

export const AddPatientButton = styled("div", {
  // EN-5191: was a fixed 90x26 sized around the English label. A longer translation
  // ("Patiënt toevoegen", "Taak toevoegen") overflowed the width and the fixed height
  // clipped the wrapped second line. The minimums leave the English button unchanged.
  width: "max-content",
  minWidth: "90px",
  minHeight: "26px",
  whiteSpace: "nowrap",
  padding: "5px 11px",

  backgroundColor: "#212121",
  borderRadius: "12px",
  color: "$white",

  fontSize: "12px",
  lineHeight: "16px",
  fontFamily: "$openSans",
  fontWeight: "500",

  position: "absolute",
  top: "8px",
  right: "1px",

  cursor: "pointer",

  "&:hover": {
    backgroundColor: "$charcoal",
  },
});

export const PatientListHeaderContainer = styled("div", {
  display: "flex",
  position: "relative",

  svg: {
    margin: "6px 6px 0 6px",
    height: "21px",
    width: "21px",
  },
});

export const TableSettingsContainer = styled("div", {
  marginTop: "3px",
  marginLeft: "2px",
  borderRadius: "50%",
  cursor: "pointer",

  "&:hover": {
    backgroundColor: "rgba(147, 147, 147, 0.12)",
  },

  "&:focus-visible": {
    outline: "none !important",
    border: "2px solid $primary-30 !important",
  },
});

export const TagContainer = styled("div", {
  div: {
    position: "inherit",
    height: "26px",
  },
});

export const LayoutCss = css({
  ".page-container": {
    display: "flex",
    flexDirection: "column",
    margin: "0px !important",

    width: "96%",
    minHeight: "calc(100% - 96px)",

    "@media(max-width: 1420px)": {
      width: "100%",
    },

    "@sm": {
      width: "100%",
      margin: 0,
    },
  },
});
